/**
 * useClientMediaQuery: Hydration-safe media query that only returns actual values after mount.
 * Ensures server and initial client render both use defaultMatches to prevent React hydration errors #418/#423/#421.
 *
 * @param {string|function} query - Media query string or theme breakpoint function
 * @param {object} options - Options object
 * @param {boolean} options.defaultMatches - Value used during SSR and initial client render (default: false)
 * @returns {boolean} - Whether the media query matches (or defaultMatches until mounted)
 */
import { useEffect, useState, startTransition } from 'react';

import { useMediaQuery } from '@mui/material';

export default function useClientMediaQuery(query, options = {}) {
    const { defaultMatches = false, ...restOptions } = options;
    const [mounted, setMounted] = useState(false);
    const matches = useMediaQuery(query, { noSsr: true, defaultMatches, ...restOptions });

    useEffect(() => {
        startTransition(() => setMounted(true));
    }, []);

    return mounted ? matches : defaultMatches;
}
